const script = document.createElement('script');
script.setAttribute('defer', true);
if( DETECT.device.any ){
	script.src = '/assets/js/'+ ENV +'-mobile.js?v=' + UNIQ_ID;
} else {
	script.src = '/assets/js/'+ ENV +'-desktop.js?v=' + UNIQ_ID;	
}
document.body.appendChild(script);